<template>
    <div>
        <h3>
            L'export Excel contient les colonnes suivantes
        </h3>

        <ul class="mb-4">
            <li><strong>An</strong> : Année</li>
            <li><strong>Mois</strong> : Numéro du mois (1 à 12)</li>
            <li><strong>Client</strong></li>
            <li><strong>Cabinet</strong> : Code du cabinet du client</li>
            <li><strong>Faturé par</strong> : Code du cabinet qui facture</li>
            <li><strong>Compte comptable</strong> : Affectation comptable</li>
            <li><strong>Montant</strong> : Crédit - débit</li>
        </ul>
        <b-alert show variant="primary">
            Les données ne concernent que l'année sélectionnée et respectent les filtres du panneau gauche. Seuls les montants concernant les affectations utilisées pour la marge sont exportés.
        </b-alert>
        <b-button
            :href="exportUrl"
            variant="success"
            class="mt-2"
        >
            <i class="fas fa-file-excel mr-2"></i>Télécharger l'export Excel
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DashboardFeesExportCa',

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            menuRoutes: (state) => state.dashboardVM.menuRoutes,
        }),

        exportUrl() {
            const base = this.menuRoutes['fees-export-ca'] || ''
            return base ? `${base}/${this.year}` : '#'
        },
    },

    mounted() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'fees-export-ca')
    },
}
</script>
